import { render, staticRenderFns } from "./carDetail.vue?vue&type=template&id=380af40c&scoped=true&"
import script from "./carDetail.vue?vue&type=script&lang=js&"
export * from "./carDetail.vue?vue&type=script&lang=js&"
import style0 from "./carDetail.vue?vue&type=style&index=0&id=380af40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380af40c",
  null
  
)

export default component.exports